// extracted by mini-css-extract-plugin
export default {"error":"style_error__lNCBt","title":"style_title__DZgLW","text":"style_text__fK8mw"};